import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./table.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faEdit, faEye, faFilter } from "@fortawesome/free-solid-svg-icons";
import Loading from "../loading/Loading";
import { SelectedInput } from "../input/SelectedInput";
import { useNavigate } from "react-router-dom";
import Modifiedicon from "../icon/Modifiedicon";
import MessageDisplay from "../message/MessageDisplay";

const TableCompo = (
    {
        title,
        permission,
        search,
        navPath,
        view,
        generate,
        data,
        setOpen,
        page,
        handleSubmit,
        setPage,
        handleSearch,
        pagination,
        uptodate,
        isLoading,
        handleGenerate,
        setSelectedData,
        prevData,
        filter,
        filterval,
        fil,
        filterOptions,
        inputValue,
        serialNo,        // boolean: show S/No column
        rowClickable,
        deleteBtn,    // boolean: enable row click/navigation
        message }) => {
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);
    const navigate = useNavigate()
    const firstRowRef = useRef(null);
    const [filters, setFilters] = useState(false)

    const filterRef = useRef(null); // 1️⃣ Create a ref
    useEffect(() => {
        function handleClickOutside(event) {
            // Check if click is outside the filter container AND outside the filter button
            if (
                filters &&
                filterRef.current &&
                !filterRef.current.contains(event.target) &&
                !event.target.closest(`.${styles.filterbtn}`) // Also check if click is not on the filter button itself
            ) {
                setFilters(false);
            }
        }

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [filters]); // Only depend on filters state


    console.log(data, title)

    useEffect(() => {
        const handleResize = () => setIsSmallScreen(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleNavigate = (id) => {
        console.log(id)
        navigate(`${navPath}/${id}`)
    }


    const currentData = data[page.pageno] || prevData;
    const excludeHeaders = ['cancelled_by', 'trip_id', 'booking_id', 'driver_ID', 'cab_id']; // Add any keys you want to skip

    const headers = useMemo(() => {
        if (currentData.length === 0) return [];
        return Object.keys(currentData[0]).filter(
            key => !excludeHeaders.includes(key)
        );
    }, [currentData]);

    const formatHeader = (header) => {
        let formatted = header.replace(/_/g, " ");
        return formatted.charAt(0).toUpperCase() + formatted.slice(1);
    };

    const value = inputValue;
    const filv = fil;

    useEffect(() => {
        if (firstRowRef.current) {
            firstRowRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [page.pageno]);

    const nah = ['notverified', 'online'];
    function isToday(dateStr) {
        const input = new Date(dateStr);
        const today = new Date();

        return input.getFullYear() === today.getFullYear() &&
            input.getMonth() === today.getMonth() &&
            input.getDate() === today.getDate();
    }

    const search_placeholder = `Search for a specific ${title === 'Driver' ? 'driver' : title === 'Passengers' ?
        'passenger' : title === 'Outstation Bookings' ?
            'booking' : 'trip'}`

    console.log({ filv, value }, 'filter and search values in table compo', title)
    const filterbtn = `Filter ${title.toLowerCase()}`

    // Central place for id-resolution used by row click navigation.
    // Falls back to '' if title doesn't match a known case.
    const getRowId = (item) => {
        if (title === "Driver") return item.driver_ID;
        if (title === "Rides") return item.trip_id;
        if (title === "Outstation Bookings") return item.booking_id;
        if (title === "Bulk Booking") return item.request_id;
        return item.trip_id ?? '';
    };

    return (
        <div className={styles.container}>
            {generate && uptodate !== null && <span className={`${styles.uptodate} ${uptodate ? styles.yes : styles.no}`}>
                {uptodate === null ? null : uptodate ? 'Generated up to date' : 'Payment generation not up to the latest week'}
            </span>}
            <div className={`${styles.heading} ${(title === 'Driver' || title === 'Rides' || title === 'Passengers' || title === 'Outstation Bookings') && styles.filter}`}>
                <h1 className={styles.header}>{title}</h1>
                {
                    search &&
                    <SelectedInput
                        value={value}
                        classname={"driverSearch"}
                        placeholder={search_placeholder}
                        onChange={handleSearch} />
                }
                <div className={styles.belowSearch}>
                    {filter &&
                        <>
                            <button
                                data-tooltip={filterbtn}
                                className={styles.filterbtn} // This class is used in the closest() check
                                onClick={() => setFilters(prev => !prev)}
                            >
                                <label style={{ fontWeight: '600', fontSize: '16px' }}>Filter</label>
                                <FontAwesomeIcon icon={faFilter} />
                            </button>
                        </>
                    }


                    {filters && (
                        <div className={styles.filtercon} ref={filterRef}>
                            {Object.entries(
                                filterOptions.reduce((acc, opt) => {
                                    (acc[opt.name] ||= []).push(opt);
                                    return acc;
                                }, {})
                            ).map(([name, options]) => (
                                <div key={name} className={styles.filterGroup}>
                                    {options.map((opt) => {
                                        const isChecked = fil?.[opt.name] === opt.value;
                                        const isSpecial = nah.includes(opt.value);
                                        return (
                                            <label key={opt.value}>
                                                <input
                                                    type="checkbox"
                                                    name={opt.name}
                                                    value={opt.value}
                                                    className={styles.check}
                                                    checked={isChecked}
                                                    onChange={() => filterval(opt.name, opt.value)}
                                                />
                                                {opt.label}
                                            </label>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                {generate && uptodate === 0 && <button onClick={handleGenerate} className={styles.generateButton}>Generate payments</button>}
                {handleSubmit && permission === true &&
                    <button className={`${styles.generateButton} ${!permission ? styles.disabled : ''}`}
                        disabled={!permission}
                        onClick={() => {
                            setOpen(true)
                            setSelectedData(null)
                        }}>ADD</button>
                }
            </div>
            {
                isLoading &&
                <div className={styles.loading}>
                    <Loading />
                </div>
            }
            {
                !isSmallScreen ? (
                    <div className={`${styles.tablecontainer}`}>
                        {message?.type && <MessageDisplay message={message} />}
                        {message && currentData.length <= 0 ? <div className={styles.nodata}>{message}</div> : null}
                        {currentData.length > 0 && (
                            <table className={`${styles.table} ${isLoading ? styles.blur : ''}`}>
                                <thead>
                                    <tr>
                                        {serialNo &&
                                            <th style={{ width: '1%', whiteSpace: 'nowrap', textAlign: 'center' }}>S/No</th>
                                        }
                                        {headers.map((header, index) => (
                                            <th key={index}>{formatHeader(header)}</th>
                                        ))}
                                        {/* {deleteBtn &&
                                            <th >Action</th>
                                        } */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentData.map((item, rowIndex) => (
                                        <tr
                                            key={rowIndex}
                                            className={`${styles.row} ${rowClickable ? styles.clickableRow : ''}`}
                                            ref={rowIndex === 0 ? firstRowRef : null}
                                            onClick={rowClickable ? () => handleNavigate(getRowId(item)) : undefined}
                                        >
                                            {
                                                serialNo &&
                                                <td className={styles.item}>
                                                    {(page.pageno - 1) * 20 + rowIndex + 1}
                                                </td>
                                            }
                                            {headers.map((key, colIndex) => (
                                                <td key={colIndex} className={styles.item}>
                                                    {key === "verification" ? (
                                                        <span className={styles.inline}>
                                                            <Modifiedicon verification={item[key]} />
                                                        </span>
                                                    ) : key === 'status' ? (
                                                        item.verification === 1 &&
                                                        <div
                                                            style={{
                                                                display: 'inline-flex',
                                                                backgroundColor: item[key] === 'online' ? 'green' : 'red',
                                                                height: '15px', width: '15px',
                                                                borderRadius: '50%'
                                                            }}
                                                        >
                                                        </div>
                                                    ) : key === 'completion_status' ? (
                                                        <div className={`${styles.completionStatus} ${styles[item[key]?.toLowerCase().replace(/\s+/g, '')] || ''}`}>
                                                            {item[key]?.toLowerCase().includes('cancelled')
                                                                ? `${item[key]} by ${item.cancelled_by.toLowerCase()}`
                                                                : item[key] ?? "-----"
                                                            }
                                                        </div>
                                                    ) : key === 'trip_date' && isToday(item[key]) ? (
                                                        `Today ${item[key].split(" ")[1]}`
                                                    ) : (
                                                        item[key] ?? "-----"
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                    {page.pageno === page.totalPage && <tr><td className={styles.lastItem} colSpan={headers.length + 5}>{`All ${title} fetched`}</td></tr>}
                                </tbody>
                            </table>
                        )}
                    </div>
                ) : (
                    <div className={styles.smallScreen}>
                        {message?.type && <MessageDisplay message={message} />}
                        {message && currentData.length <= 0 ? <div className={styles.nodata}>{message}</div> : null}
                        {currentData.length > 0 && (
                            currentData.map((item, index) => (
                                <div key={index}
                                    className={title === 'Payment' || title == "Price rating" ? styles.paymentItemDetails : styles.itemDetails}
                                    role={rowClickable ? "button" : undefined}
                                    tabIndex={rowClickable ? 0 : undefined}
                                    onClick={() => {
                                        if (!rowClickable) return;
                                        handleNavigate(getRowId(item));
                                    }}
                                >
                                    {title === "Payment" || title == "Price rating"
                                        ?
                                        <>
                                            {Object.keys(item).map((key, idx) => (
                                                <div key={idx} className={styles.payitem}>
                                                    <strong>{formatHeader(key)}:</strong>
                                                    <span>
                                                        {item[key] || 'null'}
                                                    </span>
                                                </div>
                                            ))}
                                            {handleSubmit && <div className={styles.itemEdit}>
                                                <button className={styles.navigateButton} onClick={() => {
                                                    setSelectedData(null); // clear first
                                                    setTimeout(() => {
                                                        setSelectedData(item);
                                                        setOpen(true);
                                                    }, 0);
                                                }}>
                                                    <FontAwesomeIcon icon={faEdit} className={styles.eye} />
                                                    Edit
                                                </button>
                                            </div>}
                                        </>
                                        : Object.keys(item).slice(0, 1).map((key, idx) => (
                                            <React.Fragment key={idx}>
                                                <div className={styles.tripid}>
                                                    <strong>{formatHeader(key)}:</strong> {item[key]}
                                                </div>
                                                {(title === "Driver" || title === "Daily rides" || title === "Passengers") && (
                                                    <div className={styles.view}>
                                                        <div className={styles.verification}>
                                                            <span className={styles.inline}>
                                                                {title === "Driver" && "verification" in item && (
                                                                    <>
                                                                        <Modifiedicon verification={item.verification} />
                                                                        {item.verification === 1 && <div style={{
                                                                            background: item.status === 'online' ? 'green' : 'red',
                                                                            height: '15px',
                                                                            width: '15px',
                                                                            borderRadius: '50%'
                                                                        }}>

                                                                        </div>}
                                                                    </>
                                                                )}

                                                                {title === "Daily rides" && "completion_status" in item && (
                                                                    item.completion_status !== null ? item.completion_status : "-----"
                                                                )}

                                                                {title === "Passengers" && "total_rides" in item && (
                                                                    item.total_rides !== null ? `${item.total_rides} rides` : "-----"
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                )}

                                            </React.Fragment>
                                        )
                                        )}
                                </div>
                            ))
                        )}
                        {page.pageno === page.totalPage && view &&
                            < span >
                                All {title} fetched
                            </span>
                        }

                    </div>
                )
            }
            {
                pagination && currentData.length > 0 && (
                    <div className={styles.footer}>
                        <h3>Total: {page.totalData}</h3>
                        <div className={styles.pageno}>
                            <button
                                disabled={page.pageno === 1 || isLoading}
                                onClick={() => setPage((prev) => ({ ...prev, pageno: prev.pageno - 1 }))}
                            >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>
                            <span>
                                Page <strong>{page.pageno}</strong> of <strong>{page.totalPage}</strong>
                            </span>
                            <button
                                disabled={page.pageno === page.totalPage || isLoading}
                                onClick={() => setPage((prev) => ({ ...prev, pageno: prev.pageno + 1 }))}
                            >
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>
                        </div>
                    </div>
                )
            }
        </div >
    );
};

export default TableCompo;